import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Heart, Sparkles, Clock } from 'lucide-react';
export function EbookIntro() {
  const features = [{
    icon: BookOpen,
    title: '6 CAPÍTULOS',
    desc: '180+ páginas\nclaras y simples'
  }, {
    icon: Heart,
    title: '4 BONUS',
    desc: 'Herramientas\nprácticas extra'
  }, {
    icon: Sparkles,
    title: 'ACOMPAÑAMIENTO',
    desc: 'Acceso desde\ncualquier dispositivo'
  }, {
    icon: Clock,
    title: 'ACCESO DE POR VIDA',
    desc: 'Releélo cuando\nlo necesites'
  }];
  return <section className="py-20 md:py-28 bg-cream overflow-hidden" data-id="element-74">
      <div className="max-w-5xl mx-auto px-6" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-77">
            🏆 EL EBOOK
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-78">
            Una guía completa para acompañarte
          </h2>
          <p className="font-serif italic text-xl md:text-2xl text-peach-dark" data-id="element-79">
            Desde el embarazo hasta los primeros meses de tu bebé
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative bg-white rounded-[2.5rem] shadow-2xl shadow-peach/20 border border-peach-light/50 overflow-hidden" data-id="element-80">
          <div className="pt-12 pb-8 px-6 md:pt-16 md:pb-12 md:px-12" data-id="element-81">
            <div className="flex justify-center mb-12" data-id="element-82">
              <div className="relative" data-id="element-83">
                <div className="absolute inset-0 bg-gradient-to-tr from-peach/10 to-sage/10 rounded-[3rem] blur-2xl scale-110" data-id="element-84"></div>
                <img src="https://cdn.magicpatterns.com/uploads/4EivNSZFoqM7bJ8DJ12EQy/Mockap_Florecer.png" alt="Ebook Florecer" className="relative z-10 w-full max-w-sm drop-shadow-2xl" data-id="element-85" />
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 pt-8 border-t border-peach-light" data-id="element-86">
              {features.map((f, idx) => <div key={idx} className="text-center px-2" data-id="element-87">
                  <div className="w-14 h-14 mx-auto mb-3 rounded-2xl bg-sage-light flex items-center justify-center" data-id="element-88">
                    <f.icon className="w-7 h-7 text-sage" strokeWidth={1.5} data-id="element-89" />
                  </div>
                  <h3 className="text-xs font-bold tracking-widest text-text-dark uppercase mb-2" data-id="element-90">
                    {f.title}
                  </h3>
                  <p className="text-xs text-text-muted leading-relaxed whitespace-pre-line" data-id="element-91">
                    {f.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}